module.exports = __webpack_public_path__ + "static/media/DD_white.3db3d9cc.png";